import ClayLayout from "@clayui/layout";
import { ClayTooltipProvider } from "@clayui/tooltip";
import { convertMinutesToDuration, getPersonas, getShortText, getTooltipPersona } from "../../utils/util";
import "./SectionCard.scss";

const SectionCard = ({
  description,
  duration,
  expertise,
  index,
  link,
  personas,
  title,
  type
}) => {
  const isSales = type === "sales";

  const containerClass =
    `section-card-container ${
      isSales 
        ? 'section-card-container-sales'
        : ''
    } d-flex`;
  const expertiseClass =
    isSales
      ? `sales-courses-card-tag__expertise-${expertise?.toLowerCase()} card-tag`
      : `card-tag card-tag__expertise-${expertise?.toLowerCase()}`;
  const tagsContainerClass =
    `card-tags-container d-flex
    ${isSales ? "flex-row" : ""}`;

  return (
    <ClayLayout.Col
      className="d-flex card-layout-col"
      key={index}
      lg={4}
      md={6}
      sm={12}
      xl={4}
      xs={12}
    >
      <a href={link} className="section-card-link">
        {isSales && (
          <div className="section-card-tag-course">
            <span>Course</span>
          </div>
        )}
        <div className={containerClass}>
          <div className="card-content d-flex flex-column justify-content-between">
            <h4 className="title">{title}</h4>
            <div className="description">{getShortText(description, 150)}</div>
            <div className={tagsContainerClass}>
              <div>
                {isSales && duration && (
                  <div className="card-tag">
                    <div className="sales-courses-card-duration-icon"></div>
                    {convertMinutesToDuration(duration)}
                  </div>
                )}
              </div>
              <ClayTooltipProvider>
                <div
                  className="card-tag card-tag__persona"
                  data-tool-tip-align="top"
                  title={getTooltipPersona(personas)}
                >
                  <p></p>
                  {getPersonas(personas)}
                </div>
              </ClayTooltipProvider>
              {expertise && (
                <div className={expertiseClass}>
                  <p>{expertise}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </a>
    </ClayLayout.Col>
  );
};

export default SectionCard;
